module.exports = __webpack_public_path__ + "img/convenio-de-practicas7.c9be5e23.png";